<template>
    <div style="text-align: left;margin-top: 2vw;padding-left: 5vw;" class="animate__animated animate__slideInLeft">
<!--        <div class="navList">-->
<!--            <p><img src="../assets/img/navImg/nav17.svg" alt=""></p>-->
<!--            <span>俱乐部介绍</span>-->
<!--        </div>-->
        <div class="navList">
            <p><img src="../assets/img/navImg/nav1.svg" alt=""></p>
            <span>球队总结</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav2.svg" alt=""></p>
            <span>伤病报告</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav3.svg" alt=""></p>
            <span>训练计划</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav4.svg" alt=""></p>
            <span>训练视频</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav5.svg" alt=""></p>
            <span>球队阵容</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav6.svg" alt=""></p>
            <span>运动表现</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav8.svg" alt=""></p>
            <span>强度报告</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav9.svg" alt=""></p>
            <span>AC报告</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav10.svg" alt=""></p>
            <span>AC目标</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav7.svg" alt=""></p>
            <span>体测报告</span>
        </div>
<!--        <div class="navList">-->
<!--            <p><img src="../assets/img/navImg/nav16.svg" alt=""></p>-->
<!--            <span>训练教案</span>-->
<!--        </div>-->
        <div class="navList">
            <p><img src="../assets/img/navImg/nav13.svg" alt=""></p>
            <span>球员评估</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav14.svg" alt=""></p>
            <span>教练员评估</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav11.svg" alt=""></p>
            <span>球员列表</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav12.svg" alt=""></p>
            <span>教练员列表</span>
        </div>
        <div class="navList">
            <p><img src="../assets/img/navImg/nav15.svg" alt=""></p>
            <span>赛程</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "main_btn",
        computed: {
            paramsCommandFn() {
                return this.$store.state.paramsCommand;
            }
        },
        watch:{
            paramsCommandFn:{
                handler(val,old){
                    /*let trainingReport = this.$aiJson.trainingReport;//训练报告关键字
                    trainingReport.some((itemR) => {
                        if (eval('/' + itemR + '/gi').test(val.split('_')[0])) {
                            return ;
                        } else {
                            this.$store.dispatch("setFlag",'0_'+new Date().getTime());//vuex改变识别信息
                        }
                    })*/
                },
                deep:true
            },
        },
        mounted() {
            console.log(this.$store.state.token)
            this.$store.state.promptMsg=this.$route.meta.promptMsg;
            this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl('请选择您想查看的内容'),true,true,1);
        },
        methods:{
            trainingFn(){
                this.$router.push({
                    path:'/about/assessmentReport',
                    name:'assessmentReport'
                });
            }
        },
    }
</script>

<style scoped lang="less">
    .navList{
        /*background: rgba(12, 12, 13, .5);*/
        background-image: url("../assets/img/updateImg/menuBg.svg");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        display: inline-block;
        width: calc(20% - 3vw);
        margin-right: 3vw;
        margin-bottom: .5vw;
        text-align: center;
        color: #fff;
        font-size: 28px;
        padding-bottom: 3.5vw;
        padding-top: 2vw;
        border-radius: 3px;
        img{
            width: 50%;
        }
        span{
            padding-top: 3vw;
        }
    }
</style>
